<template>
  <div id="content">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'app-content'
}
</script>

